import React from "react";
import { AnimateIn } from "./AnimateIn";
import "./CtaSection.css";

export const CtaSection = ({ data }) => {
  if (!data) return null;

  return (
    <section className="cta-section">
      <div className="section-container">
        <AnimateIn variant="scaleUp" duration={0.8}>
          <div className="cta-card">
            <h2 className="cta-title">{data.title}</h2>
            <p className="cta-subtitle">{data.subtitle}</p>
            <a className="cta-button" href={data.url}>
              {data.button} →
            </a>
          </div>
        </AnimateIn>
      </div>
    </section>
  );
};
